module.exports = "https://cdn.hellotech.com/client-assets/simpliSafepkg_square_71ea88d24799b9cb99d69f4a6aa3c3ae.jpg";